module.exports = __webpack_public_path__ + "img/bg2@2x 2.31d78eb4.png";